import React from 'react';

import positiony from '../Support/Positiony';

const tooltrip = (props) => {

	if(!props.active || !props.payload)
		return null;

	const kind = props.payload[0].payload.kind !== undefined ? props.payload[0].payload.kind : null;
	const slot = props.payload[0].value;
	const value = positiony(props.payload[1].value).toString();

	let label = 'Position';
	if(kind === 'offer') label = 'Offer';
	else if(kind === 'counter') label = 'Counter Offer';

	let accepted = '';
	if(props.payload[0].payload.accepted) accepted = ' (ACCEPTED)';

	return (
		<div className="position-graph__tooltip">
			<p className="position-graph__tooltip__line position-graph__tooltip__line--bold">{label} {slot}{accepted}</p>
			<p className="position-graph__tooltip__line">Value: {value}</p>
		</div>
	);
}

export default tooltrip;


// WEBPACK FOOTER //
// ./src/Blocks/Tooltrip.js